import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("onboardingStore");

const urls = {
  getMyData: `/administration/self-onboarding/my-data`,
  getMyBranding: `/administration/self-onboarding/my-branding`,
  fetchMerchantCategories: `/merchant/merchant-category-selects`,
  putOnboardingData: `/administration/self-onboarding/continue`,
  putBranding: `/administration/self-onboarding/branding`,
  downloadFile: (id) => `/file/download/${id}`,
  generateDocument: (fieldId, configId) =>
    `/administration/self-onboarding/generate/special/${fieldId}/question/${configId}`,
  uploadDocument: `/administration/self-onboarding/upload`,
  doesFinancierExist: (financier) =>
    `/administration/self-onboarding/exists-financier/${financier}`,
};

const initState = () => {
  return {
    onboardingData: {},
    onboardingDataValidity: true,
    branding: {},
    merchantCategories: [],
  };
};

const actions = {
  getMyData: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.getMyData);
      commit("saveOnboardingData", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  getMyBranding: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.getMyBranding);
      commit("saveBranding", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchMerchantCategories: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.fetchMerchantCategories);
      commit("saveMerchantCategories", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  putOnboardingData: async (_, body) => {
    try {
      const axios = await network.connection();
      await axios.put(urls.putOnboardingData, body);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  putBranding: async (_, body) => {
    try {
      const axios = await network.connection();
      await axios.put(urls.putBranding, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  downloadFile: async (_, id) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.downloadFile(id), {
        responseType: "blob",
      });
      return data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  downloadDocument: async (_, id) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.downloadFile(id), {
        responseType: "blob",
      });
      return data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  generateDocument: async (_, { fieldId, configId }) => {
    try {
      const axios = await network.connection();
      const response = await axios.post(
        urls.generateDocument(fieldId, configId),
        {},
        { transformResponse: (data) => `${data}` }
      );
      console.log(response);
      return response.data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  uploadDocument: async () => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.uploadDocument);
      return data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  doesFinancierExist: async (_, financier) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.doesFinancierExist(financier));
      return data;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveOnboardingData: (state, data) => {
    Vue.set(state, "onboardingData", data);
  },
  saveBranding: (state, data) => {
    Vue.set(state, "branding", data);
  },
  saveMerchantCategories: (state, data) => {
    Vue.set(state, "merchantCategories", data);
  },
  setOnboardingDataValidity: (state, data) => {
    Vue.set(state, "onboardingDataValidity", data);
  },
};

const getters = {
  onboardingData: (state) => {
    return state.onboardingData;
  },
  branding: (state) => {
    return state.branding;
  },
  merchantCategories: (state) => {
    return state.merchantCategories;
  },
  getOnboardingDataValidity: (state) => {
    return state.onboardingDataValidity;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
